// Add a store (demo: Groups & labels › Hierarchy): customer, city, area,
// store name, address -> label values with display names (data/stores.ts).
import { useState } from "preact/hooks";
import { useT } from "../i18n";
import { tree } from "../lib/account";
import { fleet, loadFleet } from "../data/fleet";
import { addStore } from "../data/stores";
import { errText } from "../lib/apierr";

export function AddStoreDialog({ city, area, onClose }: { city?: string; area?: string; onClose: (done: boolean) => void }) {
  const t = useT();
  const names = (lv: string) => { const out = new Map<string, string>(); const walk = (n: { level: string; value: string; name: string; children: unknown[] }) => { if (n.level === lv) out.set(n.value, n.name); (n.children as typeof n[]).forEach(walk); }; if (fleet.value) walk(fleet.value.root as never); return [...out.values()]; };
  const [f, setF] = useState({ account_id: tree.value.find((r) => r.a.kind === "customer")?.a.id || "", city: city || "", area: area || "", name: "", address: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k: string) => (e: Event) => setF({ ...f, [k]: (e.target as HTMLInputElement).value });
  const save = async (e: Event) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await addStore(f); await loadFleet(t.lang); onClose(true); } catch (x) { setErr(errText(t, x)); }
    setBusy(false);
  };
  return (
    <div class="modal" onClick={(e) => e.target === e.currentTarget && onClose(false)}>
      <form class="box card" style="width:min(560px,100%)" onSubmit={save}>
        <h2 style="margin:0">{t("x.store.add")}</h2>
        <p style="margin:0;color:var(--muted)">{t("x.store.text")}</p>
        <label class="f">{t("app.customer")}<select required value={f.account_id} onChange={set("account_id")}>{tree.value.filter((r) => r.a.parent_id).map(({ a, depth }) => <option key={a.id} value={a.id}>{"  ".repeat(depth - 1)}{a.name}</option>)}</select></label>
        <div class="g3" style="grid-template-columns:1fr 1fr;gap:10px">
          <label class="f">{t("lvl.city")}<input required list="st-city" value={f.city} placeholder="Lugano" onInput={set("city")} /><datalist id="st-city">{names("city").map((v) => <option key={v} value={v} />)}</datalist></label>
          <label class="f">{t("lvl.area")}<input required list="st-area" value={f.area} placeholder="Centro" onInput={set("area")} /><datalist id="st-area">{names("area").map((v) => <option key={v} value={v} />)}</datalist></label>
        </div>
        <label class="f">{t("lvl.site")}<input required value={f.name} placeholder="Lugano Via Nassa" onInput={set("name")} /></label>
        <label class="f">{t("x.store.address")}<input value={f.address} placeholder="Via Nassa 22, 6900 Lugano" onInput={set("address")} /></label>
        {err && <p class="st st-crit" style="margin:0">{err}</p>}
        <div class="row" style="justify-content:flex-end"><button class="btn" type="button" onClick={() => onClose(false)}>{t("alm.cancel")}</button><button class="btn pri" type="submit" disabled={busy}>{t("x.store.add")}</button></div>
      </form>
    </div>
  );
}
